// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__LnqMd","amount":"Amount_amount__jHBvK","tip":"Amount_tip__Vyw0e","tipHeader":"Amount_tipHeader__17CeJ","tipsWrap":"Amount_tipsWrap__Ye2UI"};